import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const MergeIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Merge",
    children: /*#__PURE__*/_jsx("path", {
      d: "M23.17 20.04C20.53 17.75 17.8 15.4 17.4 10v-.27h3.42c.6-.01 1.07-.5 1.07-1.1 0-.19-.05-.37-.13-.52s-4.81-5.59-4.81-5.59c-.16-.31-.48-.52-.86-.52s-.69.21-.85.52-4.81 5.63-4.81 5.63c-.09.15-.14.33-.14.52 0 .56.43 1.03.99 1.07h3.28v.27c-.36 5.42-3.09 7.78-5.77 10.06-2.42 2.1-4.96 4.27-4.96 8.47 0 .8.65 1.44 1.44 1.44s1.44-.65 1.44-1.44c0-2.88 1.66-4.31 3.97-6.29 2.19-1.68 3.97-3.77 5.25-6.17l.05-.1c1.33 2.49 3.11 4.58 5.24 6.23l.04.03c2.31 2 3.98 3.43 3.98 6.32 0 .8.65 1.44 1.44 1.44s1.44-.65 1.44-1.44c0-4.22-2.54-6.4-4.98-8.52Z"
    })
  }));
};